import { useTranslation } from 'react-i18next';
import { StatCounter } from '@/components/home/StatCounter';
import { TreePine } from 'lucide-react';

export const SustainabilityBanner = ({ sustainability, heroCO2Display }) => {
  const { t } = useTranslation();
  if (!sustainability) return null;

  return (
    <section
      className="bg-gradient-to-br from-emerald-50 via-white to-emerald-50/40 dark:from-emerald-950/40 dark:via-slate-900 dark:to-emerald-950/30 border-b border-emerald-200/60 dark:border-emerald-800/40"
      data-testid="sustainability-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center justify-between gap-6 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 bg-emerald-600 text-white flex items-center justify-center">
              <TreePine className="h-5 w-5" />
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-emerald-700 dark:text-emerald-300">
                {t('home.sustain.liveImpact')}
              </p>
              <p className="text-xs text-slate-600 dark:text-slate-300">
                {t('sustainability.impactBanner', 'Gemeinsam vermeiden wir Verpackungsabfall und sparen Ressourcen.')}
              </p>
            </div>
          </div>
          <div className="flex items-stretch gap-6 md:gap-10 flex-wrap">
            <div data-testid="sustainability-co2">
              <StatCounter
                value={heroCO2Display.value}
                decimals={heroCO2Display.decimals}
                suffix={heroCO2Display.unit}
                className="text-xl md:text-2xl font-bold text-emerald-700 dark:text-emerald-300"
              />
              <p className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-slate-400 mt-0.5">
                {t('home.sustain.co2')}
              </p>
            </div>
            <div className="w-px bg-emerald-200 dark:bg-emerald-800/50" aria-hidden />
            <div data-testid="sustainability-redistributed">
              <StatCounter
                value={sustainability.materials_redistributed}
                className="text-xl md:text-2xl font-bold text-slate-900 dark:text-slate-50"
              />
              <p className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-slate-400 mt-0.5">
                {t('home.sustain.redistributed')}
              </p>
            </div>
            <div className="w-px bg-emerald-200 dark:bg-emerald-800/50 hidden sm:block" aria-hidden />
            <div className="hidden sm:block" data-testid="sustainability-sites">
              <StatCounter
                value={sustainability.active_sites}
                className="text-xl md:text-2xl font-bold text-slate-900 dark:text-slate-50"
              />
              <p className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-slate-400 mt-0.5">
                {t('home.sustain.sites')}
              </p>
            </div>
            <div className="w-px bg-emerald-200 dark:bg-emerald-800/50 hidden md:block" aria-hidden />
            <div className="hidden md:block">
              <StatCounter
                value={sustainability.circular_economy_rate}
                decimals={1}
                suffix=" %"
                className="text-xl md:text-2xl font-bold text-emerald-700 dark:text-emerald-300"
              />
              <p className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-slate-400 mt-0.5">
                {t('home.sustain.circular')}
              </p>
            </div>
            <div className="w-px bg-emerald-200 dark:bg-emerald-800/50 hidden lg:block" aria-hidden />
            <div className="hidden lg:block" data-testid="sustainability-at-risk">
              <StatCounter
                value={sustainability.at_risk_materials}
                className="text-xl md:text-2xl font-bold text-amber-600 dark:text-amber-400"
              />
              <p className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-slate-400 mt-0.5">
                {t('home.sustain.atRisk')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
